import { useReviewAnchors } from "@components/QaReview/hooks/useReviewAnchors";
import { useReviewSession } from "@components/QaReview/hooks/useReviewSession";

/**
 * The field the active review card points at: a rio left edge and a light fill, drawn on a layer behind the
 * field so it covers radio and checkbox fields too and never moves the field the card stack anchors to.
 */
export const ACTIVE_REVIEW_FIELD_CLASSNAME =
  "relative isolate before:absolute before:-inset-x-3 before:-inset-y-2 before:-z-10 before:rounded-md before:bg-limestone-50 before:shadow-[inset_3px_0_0_var(--color-rio-600)]";

export const useFieldReview = () => {
  const { state, dispatch } = useReviewSession();
  const { firstOpenIdForField } = useReviewAnchors();

  const isActive = (fieldId: string | undefined) => !!fieldId && state.active?.fieldId === fieldId;

  const activate = (fieldId: string | undefined) => {
    if (!fieldId || isActive(fieldId)) return;
    const itemId = firstOpenIdForField(fieldId);
    if (itemId) dispatch({ type: "activate", fieldId, itemId });
  };

  const deactivate = (fieldId: string | undefined) => {
    if (fieldId) dispatch({ type: "deactivate", fieldId });
  };

  return { isActive, activate, deactivate };
};
